import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Col, Row } from "reactstrap";
import { Line } from 'react-chartjs-2';
import PageTitle from "Layout/Components/PageTitle";
import BoxValue from "./BoxValue";
import { statisticsOverview } from "API/StatisticsAPI";

class StatisticsOverview extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      today: this.buildData(),
      last7Days: this.buildData(),
      last30Days: this.buildData(),
      last2Years: this.buildData()
    }
  }

  buildData() {
    return {
      total: 0,
      details: []
    };
  }

  componentDidMount() {
    statisticsOverview().then(result => {
      this.setState({
        today: result.data.find(item => item.period === 1),
        last7Days: result.data.find(item => item.period === 7),
        last30Days: result.data.find(item => item.period === 30),
        last2Years: result.data.find(item => item.period === 10000)
      });
    }).catch((error) => {
      console.error("Error fetching statistics data:", error);
    });
  }

  render() {
    const { t, i18n } = this.props;

    const { today, last7Days, last30Days, last2Years } = this.state;

    const buildGraphOptions = (title, timeUnit, maxY) => {
      return {
        maintainAspectRatio: true,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: timeUnit
            },
            gridLines: {
              display: true,
              lineWidth: 0
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: Math.ceil((maxY - 0) / 6),
              maxTicksLimit: 6,
              max: maxY
            },
            gridLines: {
              display: true,
              lineWidth: 0
            }
          }]
        },
        title: {
          display: true,
          text: title
        }
      };
    }

    const builGraphData = (data, color) => {
      return {
        datasets: [
          {
            label: t("statistics.requests"),
            data: data.details ? data.details.map(item => ({ x: item.date, y: item.total })) : [],
            backgroundColor: color,
            borderColor: color,
            fill: false,
          }
        ]
      };
    }
    
    const calculateMaxY = (data) => {
      if (!data || !data.details || data.details.length === 0) {
        return 1;
      }
      return Math.max(...data.details.map(item => item.total));
    }

    const requestsTodayData = builGraphData(today, "#2980b9");
    const requestsLast7DaysData = builGraphData(last7Days, "#76a96c");
    const requestsLast30DaysData = builGraphData(last30Days, "#fb4c2f");
    
    return (
      <Fragment>
        <PageTitle
          heading={t("statistics.overview.title")}
          icon="pe-7s-graph2 icon-gradient bg-primary"
        />
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="3">
              <BoxValue heading={t("statistics.today")} value={today.total} color="ev-blue" textColor="ev-white" />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-7-days")} value={last7Days.total} color="ev-green" textColor="ev-white" />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-30-days")} value={last30Days.total} color="ev-red" textColor="ev-white" />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-2-years")} value={last2Years.total} color="ev-yellow" textColor="ev-white" />
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <div className="text-center">
                <h5>{t("statistics.requests-per-hour")}</h5>
              </div>
              <Line data={requestsTodayData} options={buildGraphOptions(t("statistics.today"), 'hour', calculateMaxY(today))} height={200} />
            </Col>
            <Col md="4">
              <div className="text-center">
                <h5>{t("statistics.requests-per-day")}</h5>
              </div>
              <Line data={requestsLast7DaysData} options={buildGraphOptions(t("statistics.last-7-days"), 'day', calculateMaxY(last7Days))} height={200} />
            </Col>
            <Col md="4">
              <div className="text-center">
                <h5>{t("statistics.requests-per-day")}</h5>
              </div>
              <Line data={requestsLast30DaysData} options={buildGraphOptions(t("statistics.last-30-days"), 'day', calculateMaxY(last30Days))} height={200} />
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    )
  }
}

export default withTranslation()(StatisticsOverview);